import { Autocomplete, TextField } from '@mui/material';
import { useMemo } from 'react';
import {
  getRegionLabel,
  getRegionOptions,
  normalizeRegionCode,
  type RegionOption,
} from '../../utils/regionOptions';

type Props = {
  value?: string | null;
  onChange: (code: string | null) => void;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  helperText?: string;
};

const RegionAutocomplete = ({
  value,
  onChange,
  label = 'Régió',
  disabled = false,
  required = false,
  error = false,
  helperText,
}: Props) => {
  const options = useMemo(() => getRegionOptions('hu'), []);
  const normalized = normalizeRegionCode(value) ?? (value?.trim() || null);
  const selected: RegionOption | null = useMemo(() => {
    if (!normalized) return null;
    return (
      options.find((o) => o.code === normalized) ?? {
        code: normalized,
        label: getRegionLabel(normalized),
      }
    );
  }, [normalized, options]);

  return (
    <Autocomplete
      options={options}
      value={selected}
      disabled={disabled}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(a, b) => a.code === b.code}
      onChange={(_e, next) => onChange(next?.code ?? null)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          error={error}
          helperText={helperText}
          fullWidth
        />
      )}
    />
  );
};

export default RegionAutocomplete;
